<template>
  <div class="content-block-wrap content-fallback" role="note">
    <p v-if="hint">{{ hint }}</p>
    <pre v-else class="content-fallback__pre">{{ preview }}</pre>
  </div>
</template>

<script setup lang="ts">
import type { ContentBlock } from '../contentBlock.types'

const props = defineProps<{
  block: ContentBlock
}>()

const hint = computed(() => {
  const t = props.block.type
  const typeStr = t === undefined || t === null ? '' : String(t)
  return typeStr ? `Unsupported block type: ${typeStr}` : 'Unsupported content block'
})

const preview = computed(() => {
  try {
    return JSON.stringify(props.block, null, 2).slice(0, 500)
  } catch {
    return String(props.block)
  }
})
</script>

<style scoped>
.content-fallback {
  margin: 0 0 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 0.9rem;
}

.content-fallback__pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.75rem;
}
</style>
